module.exports = __webpack_public_path__ + "static/media/min_pub_tutelar.ccd3982a.PNG";